import React, { useState } from 'react';
import Modal from '../Modal';
import CheckBox from '../CheckBox';
import RulesTable from './RulesTable';
import RuleModal from './RuleModal';

import { ReactComponent as PlusIcon } from '../images/plus.svg';

const RulesModal = ({ setVisible, config, setConfig }) => {
  let [rules, setRules] = useState(() => config.rules.map(r => ({ ...r })));
  let [isActive, setIsActive] = useState(config.is_active);
  let [action, setAction] = useState(config.action);
  let [ruleModalVisible, setRuleModalVisible] = React.useState(false);
  let [ruleIndex, setRuleIndex] = React.useState(null);

  return (
    <>
      {ruleModalVisible && <RuleModal setVisible={setRuleModalVisible}
                                      rules={rules}
                                      setRules={setRules}
                                      index={ruleIndex} /> }

      <Modal isOpen={true}
             zIndex={300}>
        <div style={{
               background: 'linear-gradient(gray, transparent)',
               position: 'absolute',
               transform: 'translate(-50%, -50%)',
               top: '50%',
               left: '50%',
               width: '800px',
               borderRadius: '10px',
             }}>
          <div
            style={{
              margin: '1px',
              borderRadius: '10px',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              padding: '20px',
              backgroundColor: 'black',
            }}>
            <div style={{
                   display: 'flex',
                   flexDirection: 'column',
                   justifyContent: 'space-between',
                   width: '100%',
                   gap: '10px',

                 }}>
              <div style={{display: 'flex',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                          }}>
                <span style={{fontSize: '22px',
                              fontWeight: 'bold',
                             }}>
                  Rules
                </span>
                <PlusIcon className='image'
                          style={{width: '15px',
                                  height: '15px',
                                  fill: 'white',
                                  cursor: 'pointer',
                                 }}
                          onClick={() => {
                            setRules([...rules, { name: '', when: '', action: 'captcha' }]);
                          }} />
              </div>


              <RulesTable rules={rules}
                          handleClick={index => {
                            setRuleIndex(index);
                            setRuleModalVisible(true);
                          }}
                          handleDelete={index => {
                            let newRules = [...rules];
                            newRules.splice(index, 1);
                            setRules(newRules);
                          }} />

              <div style={{display: 'flex',
                           gap: '10px',
                           alignItems: 'center',
                          }}>
                <CheckBox
                  checked={isActive}
                  onChange={(e) => {
                    setIsActive(e.target.checked);
                  }}/>

                <span style={{color: 'white',
                              fontSize: '18px',
                             }}>
                  is active?
                </span>
              </div>

              <div style={{display: 'flex',
                           flexDirection: 'row',
                           alignItems: 'center',
                           marginTop: '10px',
                           gap: '10px',
                           justifyContent: 'center',
                          }}>
                <div style={{alignItems: 'center',
                             padding: '10px 20px',
                             border: '1px solid #e0e0e0',
                             borderRadius: '5px',
                             cursor: 'pointer',
                             fontWeight: 'bold',
                             alignSelf: 'flex-end',
                             display: 'flex',
                             justifyContent: 'center',
                            }}
                     onClick={() => setVisible(false)}>
                  Cancel
                </div>
                <div style={{alignItems: 'center',
                             padding: '10px 20px',
                             backgroundColor: '#009de6',
                             color: 'white',
                             borderRadius: '5px',
                             cursor: 'pointer',
                             fontWeight: 'bold',
                             alignSelf: 'flex-end',
                             display: 'flex',
                             justifyContent: 'center',
                            }}
                     onClick={() => {
                       setConfig(prev => ({
                         ...prev,
                         action,
                         is_active: isActive,
                         rules: rules.map(r => ({ ...r })),
                       }));

                       setVisible(false);
                     }}>
                  Save
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default RulesModal;
